import { z } from 'zod'

// Define reusable sub-schemas
const imageSchema = z.object({
  imageId: z.string().optional(),
  mimetype: z.string().optional(),
  seoName: z.string().optional(),
  imageAltText: z.string().optional(),
  width: z.number().optional(),
  height: z.number().optional(),
  crop: z.object({
    x1: z.string(),
    y1: z.string(),
    x2: z.string(),
    y2: z.string()
  }).optional()
})

const teaserSchema = z.object({
  // You'll need to define the teaser schema structure
  // This was referenced in the original but not defined
}).optional()

export const metaDataSchema = z.object({
  nudeContent: z.boolean().optional(),
  excludeFromAmp: z.boolean().optional(),
  advertorial: z.boolean().optional(),
  isDuplicate: z.boolean().optional(),
  cooperations: z.array(z.string()).optional(),
  hideAdvertorial: z.boolean().optional(),
  disallowAds: z.boolean().optional(),
  disallowPosterAds: z.boolean().optional(),
  disallowTaboola: z.boolean().optional(),
  disallowALinks: z.boolean().optional(),
  disallowNativeTeasers: z.boolean().optional(),
  structuredData: z.array(z.object({}).passthrough()).optional(),
  structuredDataFields: z.object({
    isNewsContent: z.boolean().optional(),
    medicalCondition: z.string().optional()
  }).optional(),
  adKeywords: z.array(z.string()).optional(),
  campaignName: z.string().optional(),
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  ogTitle: z.string().optional(),
  ogDescription: z.string().optional(),
  ogImage: imageSchema.optional(),
  trackingPixelTeaser: z.string().optional(),
  trackingPixelContent: z.string().optional(),
  adaTrackingPixelIdContent: z.number().optional(),
  respondiTrackingPixelContent: z.string().optional(),
  clickCommand: z.string().optional(),
  presenter: imageSchema.optional(),
  nativeHeader: z.object({
    headerType: z.string(),
    headline: z.object({
      text: z.string(),
      url: z.string()
    }),
    image: z.object({}).passthrough(),
    iFrame: z.string(),
    pageStrip: z.string()
  }).optional(),
  pagestripMainId: z.string().optional(),
  hideSourceName: z.boolean().optional(),
  printUsage: z.object({
    brand: z.string(),
    issue: z.string(),
    year: z.number()
  }).optional(),
  noIndex: z.boolean().optional(),
  noIndexFollow: z.boolean().optional(),
  shorttermContent: z.boolean().optional(),
  newsContent: z.boolean().optional(),
  evergreenContent: z.boolean().optional(),
  advisoryContent: z.boolean().optional(),
  isContentHubContent: z.boolean().optional(),
  aiGeneratedContent: z.boolean().optional(),
  papContent: z.boolean().optional(),
  isContentCommerce: z.boolean().optional(),
  cocoContent: z.boolean().optional(),
  affiliateContent: z.boolean().optional(),
  wordCount: z.number().optional(),
  charCount: z.number().optional(),
  hasVideo: z.boolean().optional(),
  hasGallery: z.boolean().optional(),
  showAffiliateDisclaimer: z.boolean().optional(),
  adAAdZone: z.string().optional(),
  adAAdKeywords: z.array(z.string()).optional(),
  adaAutoNative: z.boolean().optional(),
  IVWTag: z.string().optional(),
  canonical: z.string().optional(),
  notOnHome: z.boolean().optional(),
  behaveLikeArticle: z.boolean().optional(),
  isPrivacyPage: z.boolean().optional(),
  dateCreated: z.string().datetime().optional(),
  dateChanged: z.string().datetime().optional(),
  publicationDate: z.string().datetime().optional(),
  displayDate: z.string().datetime().optional(),
  hideDisplayDate: z.boolean().optional(),
  creator: z.string().optional(),
  restrictedToRoles: z.array(z.string()).optional(),
  nativeCrossbarTop: z.array(teaserSchema).optional(),
  nativeCrossbarBottom: z.array(teaserSchema).optional(),
  teaser: teaserSchema,
  asideTeasers: z.array(teaserSchema).optional()
})

export type MetaData = z.infer<typeof metaDataSchema>
